import { render, staticRenderFns } from "./UserDetailContactsTile2.vue?vue&type=template&id=5a35c5d0&scoped=true&lang=pug&"
import script from "./UserDetailContactsTile2.vue?vue&type=script&lang=js&"
export * from "./UserDetailContactsTile2.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailContactsTile2.vue?vue&type=style&index=0&id=5a35c5d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a35c5d0",
  null
  
)

export default component.exports